import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'success'>('idle');

  const categoryLinks = [
    { label: 'Shoes', href: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { label: 'Hoodies &amp; Sweaters', href: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
    { label: 'T-Shirts', href: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
    { label: 'Jackets', href: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  ];

  const resourceLinks = [
    { label: 'Buying Guide', href: '/vigorbuy-sheet-seo-guide', isRoute: true },
    { label: 'Safety Tips', href: '/#about' },
    { label: 'Category Guide', href: '/#categories' },
    { label: 'FAQ', href: '/#faq' },
  ];

  const legalLinks = [
    { label: 'Privacy Policy', href: '#' },
    { label: 'Terms of Use', href: '#' },
    { label: 'Disclaimer', href: '#' },
    { label: 'Contact', href: '#' },
  ];

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 pt-16 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-16">
          <div>
            <Link to="/" className="flex items-center gap-3 group mb-5">
              <div className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-file-list-3-line text-background-50 text-xl"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50 tracking-tight">
                VigorBuy
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed mb-6">
              Your ultimate resource for smarter shopping. Browse updated buying guides, product comparisons, and category recommendations — all in one place.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-md bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer"
                aria-label="Main store"
              >
                <i className="ri-store-line text-background-100 text-sm"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-md bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-line text-background-100 text-sm"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-md bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-background-100 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-5 uppercase tracking-wider">
              Categories
            </h4>
            <ul className="space-y-3">
              {categoryLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    dangerouslySetInnerHTML={{ __html: link.label }}
                  ></a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-5 uppercase tracking-wider">
              Resources
            </h4>
            <ul className="space-y-3">
              {resourceLinks.map((link) => (
                <li key={link.label}>
                  {link.isRoute ? (
                    <Link
                      to={link.href}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-5 uppercase tracking-wider">
              Legal
            </h4>
            <ul className="space-y-3">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <p className="text-xs text-background-400 mb-3">
                Stay updated with the latest resources
              </p>
              <form
                className="flex gap-2"
                action="https://readdy.ai/api/form/d90jbfq181e9e92u9470"
                method="POST"
                encType="application/x-www-form-urlencoded"
                data-readdy-form="true"
                onSubmit={(e) => {
                  const honeypot = (e.target as HTMLFormElement).querySelector('[name="website_alt"]') as HTMLInputElement;
                  if (honeypot && honeypot.value.trim() !== '') {
                    e.preventDefault();
                    setSubscribeStatus('success');
                    return;
                  }
                }}
              >
                <input
                  type="email"
                  name="email"
                  placeholder="Your email"
                  required
                  className="flex-1 px-4 py-2.5 rounded-md bg-background-800 border border-background-700 text-sm text-background-100 placeholder:text-background-500 focus:outline-none focus:border-primary-500 transition-colors duration-200"
                />
                <button
                  type="submit"
                  className="px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  Subscribe
                </button>
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                />
              </form>
              {subscribeStatus === 'success' && (
                <p className="mt-2 text-xs text-accent-300">
                  Thank you for subscribing!
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            <span className="font-heading text-sm text-background-300">© VigorBuy {new Date().getFullYear()}</span>
            <span className="mx-2">—</span>
            All rights reserved. This website provides educational information only.
          </p>
          <p className="text-xs text-background-500">
            Updated: {new Date().toISOString().split('T')[0]}
          </p>
        </div>
      </div>
    </footer>
  );
}